{
  "version": 1,
  "asset_id": "41964fa1-b45f-429f-ad73-bccc7e5ad639",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/41964fa1-b45f-429f-ad73-bccc7e5ad639/bypass-revision-downsizing-en-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/41964fa1-b45f-429f-ad73-bccc7e5ad639/bypass-revision-downsizing-en-1200.webp",
  "original_filename": "bypass-revision-downsizing-en-1200.webp",
  "size": 87748,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:11:48Z"
}
